import axios from "axios";
// Create an Axios instance
const axiosInstance = axios.create();

axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${process.env.REACT_APP_QM_REPORTS_BACKEND_ACCESS_KEY}`;

export default axiosInstance;
